import OwnerEntityAddress from './OwnerEntityAddress';

export default OwnerEntityAddress;
